import { render, staticRenderFns } from "./LegendDiagnosis.vue?vue&type=template&id=9bc29adc&"
import script from "./LegendDiagnosis.vue?vue&type=script&lang=js&"
export * from "./LegendDiagnosis.vue?vue&type=script&lang=js&"
import style0 from "./LegendDiagnosis.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports